import axios, { Method, AxiosResponse } from 'axios'

export const getFirstValidUrl = (arr: string[], index: number, action: Method = 'options'): Promise<string> => {
  return axios({
    method: action,
    url: arr[index],
  })
    .then(() => arr[index])
    .catch((e) => {
      if (index < arr.length - 1) {
        return getFirstValidUrl(arr, index + 1, action)
      }
      throw e
    })
}

export const deserializeRestApiResponse = <Type>(response: AxiosResponse): Type => response.data as Type
